import dayjs from "dayjs";


export enum RateActions {
  NEW = "NEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

export enum FilterActions {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
}

export const HistoryTableActionFilters = [
  { text: "Add", value: FilterActions.ADD },
  { text: "Edit", value: FilterActions.EDIT },
  { text: "Delete", value: FilterActions.DELETE },
];

export const RATE_DRAWER_DEFAULT = {
  rateId: -1,
  visible: false,
  title: "",
  type: RateActions.NEW,
};

export const INITIAL_STANDARD_RATE_DETAIL = {
  rate: null,
  effectiveDate: dayjs(),
  comment: "",
};
